export const NEW_TRATTA = "__new__";
export const NEW_AREA_CAVO = "__new_area__";
export const NONE = "__none__";
